import { useAppSelector } from 'store/hooks';
import { AcquiringsCards } from 'views/components/base/acquirings-cards';
import { FormType } from 'views/components/base/form-type';

const PaymentBoxModal = () => {
  const { acquiring } = useAppSelector((state) => state.payment);

  return acquiring ? <FormType /> : <AcquiringsCards />;
};

export { PaymentBoxModal };
